import type { OrganizationEnvironmentResourceReadApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { OrganizationEnvironment } from '../../models/organizationEnvironment.model';

export function mapOrganizationEnvironmentResponse(
  response: OrganizationEnvironmentResourceReadApi,
): OrganizationEnvironment {
  return {
    id: response.id,
    name: response.name,
  };
}
